<template>
  <b-modal size="lg"
           v-model="showModal"
           @ok="submitForm"
           :ok-disabled="isAdding">
    <div slot="modal-title">
      {{$t('message.menu.company_address')}}
    </div>
    <section>
      <div class="mb-3">
        <button class="btn btn-info" @click="changePageModal">
          {{ showTextTitle }}
        </button>
      </div>

      <template v-if="formAction === 'choose'">
        <table class="table">
          <thead class="thead-light">
          <tr>
            <th scope="col">{{ $t('message.company_address.choose') }}</th>
            <th scope="col">{{ $t('message.company_address.company_customer_name') }}</th>
            <th scope="col">{{ $t('message.company_address.address') }}</th>
            <th scope="col">{{ $t('message.company_address.action') }}</th>
          </tr>
          </thead>
          <tbody>

          <tr v-for="(company,index) in companies" :key="company.id">
            <td>
              <div class="form-check">
                <input class="form-check-input" type="radio" v-model="selectedUserCompany"
                       name="exampleRadios" :id="'company'+(index+1)"
                       :value="company" :data-id-company="company.id"
                       :disabled="!company.address_province_id">
                <label class="form-check-label" :for="'company'+(index+1)">
                </label>
              </div>
            </td>
            <td>
              <div>{{ company.company }}</div>
              <div>Tax ID: {{ company.tax_id }}</div>
              <div class="mt-2">
                <span class="badge badge-pill badge-light" style="background-color: #E0E0E0;">
                  {{ company.is_company ? $t('message.company_address.juristic_person') : $t('message.company_address.normal_person') }}
                </span>
              </div>
            </td>
            <td>
              {{ company.address }}
              <div class="text-danger mt-2" v-if="!company.address_province_id">
                <i class="fas fa-exclamation-triangle -status-alert"> </i>  {{ $t('message.company_address.incomplete_data') }}
              </div> 
            </td>
            <td>
              <a href="" @click.prevent="setUserAddressData(index)">
                {{ $t('message.button.edit') }}
              </a>
            </td>
          </tr>
          </tbody>
        </table>
      </template>

      <template v-else-if="formAction === 'add' || formAction === 'edit'">
        <company-address-form ref="companyAddressForm" @finished="finishUpdate()" />
      </template>
    </section>

    <div slot="modal-cancel" @click="showModal = false">{{ $t('message.button.close') }}</div>
    <div slot="modal-ok">
      {{ submitButtonText }}
    </div>
  </b-modal>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import CompanyAddressForm from '../components/CompanyAddressForm'

  export default {
    props: {
      manageData: Boolean,
      modalTitle: String
    },
    name: 'ModalCompanyAddress',
    components: {
      CompanyAddressForm
    },
    data () {
      return {
        showModal: false,
        selectedUserCompany: null,
        formAction: 'add'
      }
    },
    computed: {
      ...mapGetters({
        preCheckoutData: 'booking/getPreCheckoutData',
        user: 'auth/getUser'
      }),
      ...mapState('companyAddress', [
        'companies',
        'isAdding'
      ]),
      showTextTitle () {
        if (!this._.isEmpty(this.companies)) {
          if (this.formAction === 'add' || this.formAction === 'edit') {
            return this.$i18n.t('message.company_address.my_address')
          } else {
            return this.$i18n.t('message.company_address.add_new_company_address')
          }
        }
      },
      submitButtonText () {
        if (this.isAdding) {
          return this.$i18n.t('message.button.loading')
        } else {
          return (this.formAction === 'add' || this.formAction === 'edit') ? this.$i18n.t('message.button.save') : this.$i18n.t('message.button.submit')
        }
      }
    },
    watch: {
      'preCheckoutData.user_company': function (newValue, oldValue) {
        this.showUserCompanyModal(false)
      },
      companies () {
        if (this.companies) {
          this.formAction = 'choose'
        }
      }
    },
    methods: {
      showUserCompanyModal (status) {
        this.showModal = status
        // Open modal
        if (status) {
          if (!this._.isEmpty(this.companies) && this.preCheckoutData.user_company) {
            this.formAction = 'choose'
            this.selectedUserCompany = this.preCheckoutData.user_company
          }
        }
      },
      clearFormData () {
        this.$refs.companyAddressForm.setEmptyForm()
      },
      setUserAddressData (index) {
        this.formAction = 'edit'
        this.$store.commit('companyAddress/SET_SELECTED_INDEX', index)
        this.$refs.companyAddressForm.setUserAddressData(index)
      },
      async finishUpdate () {
        if (this.formAction === 'edit') {
          const queryData = {user_id: this.user.id}
          await this.$store.dispatch('companyAddress/LOAD_COMPANY_ADDRESS', queryData)
          this.formAction = 'choose'
        }
      },
      submitForm (evt) {
        // Prevent modal from closing
        evt.preventDefault()
        if (this.formAction === 'choose') {
          this.preCheckoutData.user_company = this.selectedUserCompany
          this.showUserCompanyModal(false)
        } else if (this.formAction === 'add') {
          this.$refs.companyAddressForm.submitFormAddress('checkout', 'add')
        } else if (this.formAction === 'edit') {
          this.$refs.companyAddressForm.submitFormAddress('company-address', 'edit')
        }
      },
      changePageModal () {
        this.formAction = (this.formAction === 'add' || this.formAction === 'edit') ? 'choose' : 'add'
        if (this.formAction === 'add' || this.formAction === 'edit') {
          this.$store.commit('companyAddress/SET_SELECTED_INDEX', null)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/booking/components/CompanyAddressModal.vue